export default __webpack_public_path__ + "static/media/gritrsport.86bf0fad.jpg";